<template>
  <el-dialog title="导入" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <!-- <p class="red">注：如果院校名称相同，会替换原有的资料</p> -->
    <p class="p-0-20">
      <el-button type="success" size="mini" @click="download('https://zx-jiaoyu.oss-cn-shenzhen.aliyuncs.com/import_user.xlsx')">下载模版</el-button>
      <a class="gray9 ml20" href="https://zx-jiaoyu.oss-cn-shenzhen.aliyuncs.com/import_user.xlsx" target="_blank" style="text-decoration: underline;">[备用]下载模版(右键另存为)</a>
    </p>
      <el-tabs>
      <el-upload
        class="upload-demo"
        ref="upload"
        action="/index.php/shop/study.import_user/import"
        accept=".xlsx,.xls"
        :limit="1"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="uploadFileSuccess"
        :auto-upload="false"
        drag
       >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将订单文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
      </el-upload>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="loading" :disabled="loading">确 定</el-button>
      </div>
  </el-dialog>
</template>

<script>
  var FileSaver = require('file-saver');
  export default {
    data() {
      return {
        loading: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
      };
    },
    props: ['open_upload', 'form'],
    created() {
      this.dialogVisible = this.open_upload;
    },
    methods: {
      /*批量发货*/
      submitUpload() {
        let self = this;
        self.$confirm('确认提交吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.$refs.upload.submit();
          })
          .catch(() => {});
      },
      //上传成功后台回调
      uploadFileSuccess(response, file, fileList){
        if(response.code==0){
          this.$notify({
            title: '成功',
            message: response.msg,
            type: 'success',
            duration: 0
          });
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        }else{
          this.$message(response.msg);//文件上传错误提示
        }
      },
      handleRemove(file, fileList) {
        //console.log(file, fileList);
      },
      handlePreview(file) {
        //console.log(file);
      } ,

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      download(url){
        FileSaver.saveAs(url);
      }
    }
  };
</script>

<style>
  .el-upload{
    display: block!important;
  }
  .el-upload-dragger{
    margin: auto!important;
  }
  .el-upload__tip,.el-upload-list__item-name{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/study/importuser/user/part/Upload.vue